import axios from 'axios';
import parse from 'html-react-parser';
import { useEffect, useRef, useState } from 'react';
import { CiEdit } from "react-icons/ci";
import { FaDownload } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import Select from 'react-select';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import SearchBox from '../Common-Components/SearchBox';
import { showTableResponse } from '../common-helpers/commonServices';
import { getCourses, handleOpenPDF, setDropDownStyle } from '../CommonHelper';
import TeacherReplyModal from './TeacherReplyModal';
import './teacherSupport.css';

const TeacherSupport = () => {
    const childRef = useRef();
    const [faculties, setFaculties] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(faculties);
    const [courses, setCourses] = useState([]);
    const [testSeries, setTestSeries] = useState([]);
    const [course, setCourse] = useState({ courseTitle: "All Courses" });

    const [loadTeacherComments, setTeacherCommentsLoading] = useState(false);


    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getTeacherComments').then((res) => {
            let teacherComments = res.data.teacherComments;  //recieving batch here
            console.log(teacherComments)
            if (teacherComments) {
                setFaculties(teacherComments);
                setChecked(teacherComments);
            }
        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message);
        })
        getCourses().then((res) => {
            const filtered = res.filter(data => data.examBodyId == 1);
            filtered.unshift({ courseTitle: "All Courses" });
            console.log(filtered);
            setCourses(filtered)

        })
        // getTestSeries().then((res) => {
        //     res.unshift({ courseTitle: "All Courses" })
        //     setCourses(res)
        // })
    }, [loadTeacherComments])

    const pageSize = 50;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    async function deleteTeacherComment(id) {
        swal({
            title: "Are you sure?",
            text: `Once deleted, you will not be able to recover this Query`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios.post(BACKEND_SERVER_URL + "/deleteTeacherComment/" + id).then((res) => {
                    if (res) {
                        swal(`Poof! Item has been deleted!`, {
                            icon: "success",
                        });
                        setTeacherCommentsLoading(!loadTeacherComments);
                    }
                }).catch(error => {
                    console.log(error.response.data)
                    toast.error(error.response.data.message)
                })
            }
        })
    }
    const selectCourseHandler = (selectedCourse) => {
        setCourse(selectedCourse);
        if (selectedCourse.courseTitle == 'All Courses') {
            setChecked(faculties);
            return;
        }
        let selectedItems = faculties.filter(topic => topic.courseId == selectedCourse.courseId)
        setChecked(selectedItems);
    }
    return (
        <>
            <div className="row ">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title p-2 mb-2">{/*  flex-wrap  */}
                                <div className="row w-100 d-flex justify-content-between">
                                    <div className="col-3">
                                        <div className="basic-dropdown">
                                            <Select
                                                value={{ value: course, label: course.courseTitle }}
                                                onChange={(selectedOption) => selectCourseHandler(selectedOption.value)}
                                                options={courses?.map((course) => ({ value: course, label: course.courseTitle }))}
                                                styles={setDropDownStyle()}
                                            />
                                        </div>
                                    </div>
                                    <div className=" ms-3 col-sm-6 input-group search-area mb-md-0 mb-3">
                                        <SearchBox setChecked={setChecked} dataArray={faculties} searchingProperty={'firstName'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#bdf8dc" }}>
                                            <tr className='text-center text-dark border border-left'>
                                                <th className=' text-center custom-table-header  p-2' >STUDENT</th>
                                                <th className=' text-center p-2 custom-table-header '>COURSE/TESTSERIES</th>
                                                <th className=' text-center custom-table-header  p-2' > QUESTION DETAILS</th>
                                                <th className=' text-center custom-table-header  p-2' > Files</th>
                                                {/* <th className='p-2  text-center custom-table-header '>REPLY</th> */}
                                                {/* <th className=' text-center custom-table-header  p-2' > C-TYPE</th> */}
                                                {/* <th className=' custom-table-header  p-2' > POST DATE</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='p-1 align-top' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="">
                                                            <h6 className='mb-0 ' style={{ fontSize: '13px', fontWeight: 'bold' }}>  {item.firstName} {' '}{item.lastName ? item.lastName : ''}{' '}
                                                                <CiEdit cursor='pointer' title='Reply' size={18} className='ms-3'
                                                                    onClick={() => childRef.current.openModal(item)} />
                                                                <MdDeleteOutline color='red' title='Delete Comment' cursor='pointer' size={18} className='ms-2' onClick={() => { deleteTeacherComment(item.sn) }} />

                                                            </h6>
                                                            <p className='p-0 m-0'>
                                                                <span className='text-primary' style={{ fontSize: '13px', fontWeight: '510' }}>Post Date : </span>
                                                                <span style={{ fontSize: '13px', whiteSpace: 'pre-wrap' }}>
                                                                    {new Date(new Date(item?.postDate).getTime() - 5.5 * 60 * 60 * 1000)
                                                                        .toLocaleDateString('en-GB')}
                                                                </span>


                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className='text-start p-1 align-top' style={{ border: "1px solid #cccccc", width: "50px" }}>
                                                        <h6 className='mb-0 ' style={{ whiteSpace: 'pre-wrap' }}>{item.title}{' '} </h6>
                                                    </td>
                                                    <td className='p-1 align-top' style={{ border: "1px solid #cccccc", minWidth: '300px' }}>
                                                        <div>
                                                            {/* <h6 className='mb-0'>
                                                                <span style={{ fontSize: '13px', fontWeight: 'bold' }}>SUBJECT : </span>
                                                                <span style={{ fontSize: '13px', fontWeight: 'bold', whiteSpace: 'pre-wrap' }}>{item?.subject?.toUpperCase()}</span>
                                                            </h6> */}
                                                            <p className='p-0 m-0 text-primary'>
                                                                <span style={{ fontSize: '13px', fontWeight: 'bold' }}> QUERY : </span>
                                                                <span style={{ whiteSpace: 'pre-wrap' }} className='teacher_support_query'>{item.commentTitle ? parse(item.commentTitle) : null}</span>
                                                            </p>
                                                            <p className='p-0 m-0 text-primary'>
                                                                <span style={{ fontSize: '13px', fontWeight: 'bold', color: "green" }}>REPLY : </span>
                                                                <span className='ps-1 teacher_support_reply' style={{ whiteSpace: 'pre-wrap' }}>{item.teacherReply ? parse(item.teacherReply) : null}</span>

                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="align-top p-3" style={{ border: "1px solid #cccccc", width: "60px" }}>
                                                        <button
                                                            className={`btn btn-sm w-100 d-flex align-items-center justify-content-center mb-2 ${item.studentFile ? 'btn-danger' : 'btn-outline-danger'}`}
                                                            style={{ opacity: item.studentFile ? 1 : 0.6, pointerEvents: item.studentFile ? 'auto' : 'none' }}
                                                            onClick={() => handleOpenPDF(item.studentFile)}
                                                        >
                                                            Student <FaDownload className="ms-2" size={15} />
                                                        </button>

                                                        <button
                                                            className={`btn btn-sm w-100 d-flex align-items-center justify-content-center ${item.teacherFile ? 'btn-success' : 'btn-outline-danger'}`}
                                                            style={{ opacity: item.teacherFile ? 1 : 0.6, pointerEvents: item.teacherFile ? 'auto' : 'none' }}
                                                            onClick={() => handleOpenPDF(item.teacherFile)}
                                                        >
                                                            Teacher <FaDownload className="ms-2" size={15} />
                                                        </button>
                                                    </td>

                                                    {/*
                                                    <td className='text-start p-1 ' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                                        <h6 className='mb-0'>{parse(item.teacherReply || '')}{' '} </h6>
                                                    </td> */}
                                                    {/* <td className='text-center p-1  column-width' style={{ border: "1px solid #cccccc", width: "80px" }}>
                                                        <h6 style={{ fontSize: '13px', fontWeight: 'bold' }} className='mb-0 '>{item.ctype == 'upload' ? <FaRegFile size={16} /> : 'Q'}{' '} </h6>
                                                    </td> */}
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(faculties, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TeacherReplyModal ref={childRef} loadTeacherComments={loadTeacherComments} setTeacherCommentsLoading={setTeacherCommentsLoading} />
        </>
    )
}

export default TeacherSupport;



